import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import { isFeatureEnabled } from 'owa-feature-flags';

export function isPolicyTipsEnabled(): boolean {
    // Policy Tips are enabled if the session data reports it to be enabled.
    // We can rely on this check to differentiate between premium consumers, as they'll have this property set.
    // We also guard it for enterprise users behind a feature flag.
    return (
        getUserConfiguration().PolicyTipsEnabled &&
        (isConsumer() || isFeatureEnabled('cmp-policyTips'))
    );
}
